export default __webpack_public_path__ + "static/media/logo.2090fe40.png";